var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCheckBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_check_big",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_checkmark"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding_box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.30220768,12.5966798 C0.911683385,12.2061555 0.911683385,11.5729905 1.30220768,11.1824662 L1.96161213,10.5230617 C2.35213643,10.1325374 2.9853014,10.1325374 3.3758257,10.5230617 L8.889,16.037 L20.6241743,4.30220768 C21.0146986,3.91168339 21.6478636,3.91168339 22.0383879,4.30220768 L22.6977923,4.96161213 C23.0883166,5.35213643 23.0883166,5.9853014 22.6977923,6.3758257 L10.2646493,18.8088659 C10.2618154,18.8117682 10.2589604,18.8146576 10.2560842,18.8175338 L9.59667975,19.4769383 C9.4464781,19.6271399 9.26038286,19.7195717 9.06600448,19.7542336 L8.94860436,19.7680984 L8.94860436,19.7680984 L8.83054159,19.7680984 C8.59463693,19.7542336 8.36270817,19.6571802 8.18246619,19.4769383 L1.30220768,12.5966798 Z",
    id: "shape_checkmark",
    fill: "#2D72FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCheckBig);
export default __webpack_public_path__ + "static/media/icn_check_big.cb505db72eccdbe4867098d12c9fc8f4.svg";
export { ForwardRef as ReactComponent };